var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "uxo-types columns is-multiline justify-content-center" },
    [
      false
        ? _c("div", { staticClass: "column d-flex" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _vm._m(5),
      _vm._v(" "),
      _vm._m(6),
      _vm._v(" "),
      _vm._m(7),
      _vm._v(" "),
      _vm._m(8),
      _vm._v(" "),
      _vm._m(9),
      _vm._v(" "),
      _vm._m(10),
      _vm._v(" "),
      _vm._m(11),
      _vm._v(" "),
      _vm._m(12),
      _vm._v(" "),
      _vm._m(13),
      _vm._v(" "),
      _vm._m(14),
      _vm._v(" "),
      _vm._m(15),
      _vm._v(" "),
      _vm._m(16),
      _vm._v(" "),
      _vm._m(17),
      _vm._v(" "),
      _vm._m(18)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "uxo-type__landmines card card--with-padding mb-1",
        attrs: { href: "/explosive-hazards" }
      },
      [
        _c("img", {
          staticClass: "uxo-type__landmines__image image mb-2",
          attrs: { src: "/img/uxo-svg/all.svg", alt: "All UXO" }
        }),
        _vm._v(" "),
        _c("h5", { staticClass: "font-weight-normal mb-1" }, [
          _vm._v("All UXO")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__landmines card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/landmines" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__landmines__image image mb-2",
            attrs: { src: "/img/uxo-svg/landmines.svg", alt: "Landmine" }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [
            _vm._v("Landmines")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__submunitions card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/submunitions" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__submunitions__image image mb-2",
            attrs: { src: "/img/uxo-svg/submunitions.svg", alt: "Submunitions" }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [
            _vm._v("Submunitions")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__grenades card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/grenades" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__grenades__image image mb-2",
            attrs: { src: "/img/uxo-svg/grenades.svg", alt: "Grenades" }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [
            _vm._v("Grenades")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__aircraft-bombs card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/aircraft-bombs" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__aircraft-bombs__image image mb-2",
            attrs: {
              src: "/img/uxo-svg/aircraft-bombs.svg",
              alt: "Aircraft Bombs"
            }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [
            _vm._v("Aircraft Bombs")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__rockets card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/rockets" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__rockets__image image pt-4px mb-2",
            attrs: { src: "/img/uxo-svg/rockets.svg", alt: "Rockets" }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [
            _vm._v("Rockets")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__missiles card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/missiles" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__missiles__image image mb-2",
            attrs: { src: "/img/uxo-svg/missiles.svg", alt: "Missiles" }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [
            _vm._v("Missiles")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__mortars card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/mortars" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__mortars__image image mb-2",
            attrs: { src: "/img/uxo-svg/mortars.svg", alt: "Mortars" }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [
            _vm._v("Mortars")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__projectiles card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/projectiles" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__projectiles__image image mb-2",
            attrs: { src: "/img/uxo-svg/projectiles.svg", alt: "Projectiles" }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [
            _vm._v("Projectiles")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__firing-devices card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/firing-devices" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__firing-devices__image image pt-4px mb-2",
            attrs: {
              src: "/img/uxo-svg/firing-devices.svg",
              alt: "Firing Devices"
            }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [
            _vm._v("Firing Devices")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__fuzes card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/fuzes" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__fuzes__image image mb-2",
            attrs: { src: "/img/uxo-svg/fuzes.svg", alt: "Fuzes" }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [
            _vm._v("Fuzes")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__fuzes card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/naval-devices" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__fuzes__image image mb-2",
            attrs: { src: "/img/uxo-svg/naval-devices.svg", alt: "Fuzes" }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [
            _vm._v("Naval Devices")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__fuzes card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/salw" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__fuzes__image image mb-2",
            attrs: { src: "/img/uxo-svg/salw.svg", alt: "Fuzes" }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [_vm._v("SALW")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__fuzes card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/ucav" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__fuzes__image image mb-2",
            attrs: { src: "/img/uxo-svg/ucav.svg", alt: "Fuzes" }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [_vm._v("UCAV")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__fuzes card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/afv" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__fuzes__image image mb-2",
            attrs: { src: "/img/uxo-svg/afv.svg", alt: "Fuzes" }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [_vm._v("AFV")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__fuzes card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/misc" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__fuzes__image image mb-2",
            attrs: { src: "/img/uxo-svg/misc.svg", alt: "Fuzes" }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [_vm._v("Misc")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__projectiles card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/ied" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__projectiles__image image mb-2",
            attrs: { src: "/img/uxo/ied.png", alt: "Projectiles" }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [_vm._v("IEDs")])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__firing-devices card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/incidents" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__firing-devices__image image pt-4px mb-2",
            attrs: { src: "/img/uxo/incidents.png", alt: "Firing Devices" }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [
            _vm._v("IED Incidents")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column d-flex" }, [
      _c(
        "a",
        {
          staticClass: "uxo-type__fuzes card card--with-padding mb-1",
          attrs: { href: "/explosive-hazards/terrorist-groups" }
        },
        [
          _c("img", {
            staticClass: "uxo-type__fuzes__image image mb-2 mt-2",
            attrs: { src: "/img/uxo/terrorist-groups.png", alt: "Fuzes" }
          }),
          _vm._v(" "),
          _c("h5", { staticClass: "font-weight-normal mb-1" }, [
            _vm._v("Terrorist Groups")
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c94a5c0a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c94a5c0a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/uxo/Types.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c94a5c0a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/uxo/Types.vue
// module chunks = 0 1